import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './App.css';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import UserDetailPage from './pages/UserDetailPage';
import AssetsPage from './pages/AssetsPage';
import AssetStatusPage from './pages/AssetStatusPage';
import SchedulePage from './pages/SchedulePage';
import FAQPage from './pages/FAQPage';
import CurationPage from './pages/CurationPage';
import MigrateImagesPage from './pages/MigrateImagesPage';
import SuperAdminAuthPage from './pages/SuperAdminAuthPage';
import SuperAdminManagementPage from './pages/SuperAdminManagementPage';
import SupportPage from './pages/SupportPage';
import { isAuthenticated } from './utils/auth';

// Protected Route Component - Ensures user is authenticated
const ProtectedRoute = ({ children }) => {
  const authenticated = isAuthenticated();
  console.log('🔐 Protected Route Check:', { authenticated });
  
  if (!authenticated) {
    console.log('⚠️ Not authenticated - redirecting to login');
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <Router>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#4ade80',
              secondary: '#fff',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <UsersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users/:userId"
          element={
            <ProtectedRoute>
              <UserDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/assets"
          element={
            <ProtectedRoute>
              <AssetsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/asset-status"
          element={
            <ProtectedRoute>
              <AssetStatusPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/schedule"
          element={
            <ProtectedRoute>
              <SchedulePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/faqs"
          element={
            <ProtectedRoute>
              <FAQPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/curation"
          element={
            <ProtectedRoute>
              <CurationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/migrate-images"
          element={
            <ProtectedRoute>
              <MigrateImagesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/super-admin-den"
          element={
            <ProtectedRoute>
              <SuperAdminAuthPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/super-admin-den/management"
          element={
            <ProtectedRoute>
              <SuperAdminManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/support"
          element={
            <ProtectedRoute>
              <SupportPage />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </Router>
  );
}

export default App;